import { Coordinates, PlayerCoordinates } from 'constants/PlayerCoordinates';
import { ISequence } from 'interfaces/tagging/ISequence';
import React, { useEffect, useState } from 'react';
import { Arrow, Layer, Stage } from 'react-konva';

interface IProps {
  sequence: ISequence[];
}

const pointsCoordinates: Coordinates = {
  1: {
    x: 219.5,
    y: 300,
  },
  2: {
    x: 219.5,
    y: 425,
  },
  3: {
    x: 350,
    y: 300,
  },
  4: {
    x: 280,
    y: 210,
  },
  5: {
    x: 90,
    y: 300,
  },
  6: {
    x: 160,
    y: 210,
  },
  7: {
    x: 130,
    y: 150,
  },
  8: {
    x: 219.5,
    y: 160,
  },
  9: {
    x: 310,
    y: 150,
  },
};

const STAGE_WIDTH = 435;
const STAGE_HEIGHT = 429;
const TOTAL_PLAYER_HEIGHT = 65;

const Connection = ({ firstPlayer, secondPlayer }: { firstPlayer: PlayerCoordinates; secondPlayer: PlayerCoordinates }) => {
  const dx = secondPlayer.x - firstPlayer.x;
  const dy = secondPlayer.y - firstPlayer.y;
  const angle = Math.atan2(-dy, dx);

  const radius = 42;

  const arrowStart = {
    x: firstPlayer.x + -radius * Math.cos(angle + Math.PI),
    y: firstPlayer.y + radius * Math.sin(angle + Math.PI),
  };

  const arrowEnd = {
    x: secondPlayer.x + -radius * Math.cos(angle),
    y: secondPlayer.y + radius * Math.sin(angle),
  };

  return (
    <Arrow points={[arrowStart.x, arrowStart.y, arrowEnd.x, arrowEnd.y]} fill='#E0E0E0' arrow='#E0E0E0' strokeWidth={2} stroke='#E0E0E0' />
  );
};

const ArrowSequence: React.FC<IProps> = (props) => {
  const { sequence } = props;
  const [coords, setCoords] = useState<Coordinates>(pointsCoordinates);

  useEffect(() => {
    const mapArea = document.querySelector('.fielding-sequence-flow')?.getClientRects()[0];

    sequence.forEach((sequenceNumber) => {
      const playerPosition = document.querySelector(`.position-${sequenceNumber}`)?.getClientRects()[0];

      if (playerPosition && mapArea) {
        setCoords((prevCoords) => {
          return {
            ...prevCoords,
            [sequenceNumber]: {
              x: playerPosition.x - mapArea.x + playerPosition.width / 2,
              y: playerPosition.y - mapArea.y + TOTAL_PLAYER_HEIGHT / 2,
            },
          };
        });
      }
    });
  }, [sequence]);

  return (
    <Stage width={STAGE_WIDTH} height={STAGE_HEIGHT} style={{ position: 'absolute' }}>
      <Layer>
        {sequence[0] && sequence[1] && <Connection firstPlayer={coords[sequence[0]]} secondPlayer={coords[sequence[1]]} />}
        {sequence[1] && sequence[2] && <Connection firstPlayer={coords[sequence[1]]} secondPlayer={coords[sequence[2]]} />}
      </Layer>
    </Stage>
  );
};

export default ArrowSequence;
